var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"datespan",class:{'normal': _vm.state == 0, 'warning': _vm.state == 1, 'error': _vm.state == 2},staticStyle:{"padding":"1px 4px 1px 4px","border-radius":"4px"}},[_vm._v(" "+_vm._s(_vm.formattedDate)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }